import css from 'styled-jsx/css';

export default css`
// 常规版
.search-container {
  .search-bar {
    padding: 31px 0;
    max-width: 1184px;
    box-sizing: border-box;
    display: flex;
    .search-bar-qrcode {
      height: 76px;
      flex: 1;
      text-align: right;
      img {
        height: 100%;
      }
    }
  }
  .no-qrcode-search-bar{
    padding: 31px 0;
  }
}

// simple版
.search-container-simple {
  height: 96px;
  .search-bar {
    height: 100%;
    padding: 0;
    display: flex;
    align-items: center;
  }
}

`